module.exports = __webpack_public_path__ + "img/116.1f2803a0.png";